import { BusinessDownloadConfig } from '../types';

const genreProfile: BusinessDownloadConfig = {
  'genre-profile': {
    apiUrl: '/api/v1/intelligence_pc/genreProfile/genre/profileExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_game_platform',
        type: 'radio',
        field: 'game_platform',
        defaultValue: 'mobile',
        options: [
          { label: 'dbi_mobile', value: 'mobile' },
          { label: 'dbi_pc', value: 'pc' },
          { label: 'dbi_console', value: 'console' },
          { label: 'Total', value: 'total' },
        ],
      },
      {
        label: 'dbi_global_view_genre',
        type: 'checkboxGroup',
        field: 'genre_types',
        defaultValue: ['main'],
        options: [
          { label: 'dbi_main_genre', value: 'main' },
          { label: 'dbi_sub_genre', value: 'sub' },
          { label: 'dbi_main_sub_genre', value: 'mainsub' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_genre_category',
            type: 'radio',
            field: 'genre_source',
            defaultValue: 'iegg',
            options: [
              { label: 'dbi_top_iegg_genre', value: 'iegg' },
              { label: 'dbi_top_dataai_genre', value: 'appannie' },
              { label: 'dbi_top_sensortower_genre', value: 'sensortower' },
            ],
          },    
        ],
      },
    ]
  },
  'genre-profile-detail': {
    apiUrl: '/api/v1/intelligence_pc/genreProfile/detail/statsExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_game_platform',
        type: 'radio',
        field: 'game_platform',
        defaultValue: 'mobile',
        options: [
          { label: 'dbi_mobile', value: 'mobile' },
          { label: 'dbi_pc', value: 'pc' },
          { label: 'dbi_console', value: 'console' },
          // { label: 'Total', value: 'total' },
        ],
      },
      {
        label: 'dbi_genre_profile_data_category',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['operation'],
        options: [
          { label: 'dbi_market_operation_data', value: 'operation' },
          { label: 'dbi_market_by_game', value: 'games' },
          { label: 'dbi_genre_profile_by_countries', value: 'countries' },
          { label: 'dbi_market_by_companies', value: 'companies' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          }
        ],
      },
    ]
  }
}

export default genreProfile;
